import './App.css';
import Layout from './routes/Layout';


function App() {
  return (
    <>
      <Layout />
    </>
  );
}

export default App;
